@if (this.currentCompanyStore.loaded()) {
  <dw-grid-list-page
    [title]="'Doc::Menu:CustomerPreparations' | abpLocalization"
    [activeView]="agGrid.activeView"
    [showCreationBtn]="false"
    [enableCreationBtn]="false"
    [showDeleteBtn]="false"
    [enableDeleteBtn]="false"
    [enableExportBtn]="enableExport"
    (exportAction)="agGrid.export()"
    [hasQuickSearch]="true"
  >
    @if (canStart || canComplete || canCancel) {
      <div dw-list-before-page-actions class="d-flex gap-1 me-2">
        @if (canStart) {
          <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1" (click)="bulkStart()">
            <i class="digi-out-play"></i>
            {{ 'Doc::CustomerPreparation:StartPreparation' | abpLocalization }}
          </button>
        }
        @if (canComplete) {
          <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1" (click)="bulkComplete()">
            <i class="digi-out-checklist"></i>
            {{ 'Doc::CustomerPreparation:CompletePreparation' | abpLocalization }}
          </button>
        }
        @if (canCancel) {
          <button type="button" class="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1" (click)="bulkCancel()">
            <i class="digi-out-arrow-back-circle"></i>
            {{ 'Doc::CustomerPreparation:CancelPreparation' | abpLocalization }}
          </button>
        }
      </div>
    }
    <dw-grid-ag-grid
      [columnDefs]="columns"
      [datasource]="datasource"
      (rowClicked)="rowClicked($event)"
      [(selectedRows)]="selectedEntities"
      (selectedRowsClicked)="selectedRowsClicked($event)"
      #agGrid
      [context]="GoliathDocumentEntityNames.CustomerPreparation.shortName"
    >
    </dw-grid-ag-grid>
  </dw-grid-list-page>
}
